import React from 'react';
import { ButtonTertiary, createBasicColorSet, cssColorValue, IconArrowRight, KeyboardDetectionProvider, makeColorSetClass, cssSpacing, } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { DELAYS, fadeInAnimation, Grid, withAnimationContext, TWO_COLUMN_MAX_WIDTH, VideoEmbed, SectionHeader, } from '../../ui';
import { youtubeIdRegex } from '../../ui/utils';
const Container = styled(Grid) `
  padding-top: ${cssSpacing('looser-3')};
  padding-bottom: ${cssSpacing('looser-3')};
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    padding-top: ${cssSpacing('looser-2')};
  }
`;
const Content = styled.div `
  grid-column: 1 / 5;
  padding-right: ${cssSpacing('looser-3')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    order: 2;
    grid-column: 1 / -1;
    padding-right: 0;
    margin-top: ${cssSpacing('looser-2')};
  }
`;
const VideoContainer = styled.div `
  grid-column: 5 / -1;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    order: 1;
    grid-column: 1 / -1;
  }
`;
const CtaContainer = withAnimationContext(styled.div `
    ${fadeInAnimation(DELAYS.FOURTH)};
    margin-top: ${cssSpacing('looser-2')};
  `);
const StyledButtonTertiary = styled(ButtonTertiary).attrs({
    condensed: true,
    buttonSize: 'sm',
    iconTrailing: () => React.createElement(IconArrowRight, { iconSize: 16 }),
}) `
  color: ${cssColorValue('textBase')};
  &:hover {
    color: ${cssColorValue('textSubdued')};
    transform: none;
  }
`;
export const VideoModule = React.forwardRef(({ supertext = '', headline = '', subtext = '', ctaLink = '', ctaText = '', videoUrl = '', btnComponent, videoControlColors, }, ref) => {
    const colorSet = (videoControlColors === null || videoControlColors === void 0 ? void 0 : videoControlColors.backgroundColor)
        ? createBasicColorSet(videoControlColors === null || videoControlColors === void 0 ? void 0 : videoControlColors.backgroundColor, videoControlColors === null || videoControlColors === void 0 ? void 0 : videoControlColors.textColor)
        : createBasicColorSet('#FFFFFF', '#000000');
    return (React.createElement(KeyboardDetectionProvider, null,
        React.createElement(Container, { className: makeColorSetClass('invertedDark') },
            React.createElement(Content, { ref: ref },
                React.createElement(SectionHeader, { eyebrow: supertext, heading: headline, body: subtext, cta: ctaLink &&
                        ctaText && (React.createElement(CtaContainer, null,
                        React.createElement(StyledButtonTertiary, { href: ctaLink, component: btnComponent }, ctaText))) })),
            React.createElement(VideoContainer, null, videoUrl.match(youtubeIdRegex) && (React.createElement(VideoEmbed, { url: videoUrl, colorSet: colorSet }))))));
});
